/** Euro amounts for PDF — space between symbol and digits for readability. */
import { formatMoney } from '../../../utils/formatMoney';

export function formatPdfEur(n) {
    return `€ ${formatMoney(n)}`;
}
